import { inject, Injectable } from '@angular/core';
import { catchError, map, of, shareReplay, switchMap } from 'rxjs';
import { EmailApiService, GlobalParticipantType } from '@vendasta/conversation';
import { ACCOUNT_GROUP_ID_TOKEN } from '../tokens';

@Injectable()
export class EmailDetailsService {
  private readonly accountGroupId$ = inject(ACCOUNT_GROUP_ID_TOKEN);
  private readonly emailApiService = inject(EmailApiService);

  public readonly emailAddress$ = this.accountGroupId$.pipe(
    switchMap((accountGroupId) => {
      if (!accountGroupId) {
        return of(null);
      }
      return this.emailApiService
        .getOwnerEmail({
          subjectParticipant: {
            participantType: GlobalParticipantType.GLOBAL_PARTICIPANT_TYPE_ACCOUNT_GROUP,
            internalParticipantId: accountGroupId,
          },
        })
        .pipe(
          map((emailRes) => emailRes.forwardingEmail ?? null),
          catchError((err) => {
            if (err.status !== 404) {
              console.warn('Error fetching forwarding email:', err.message);
            }
            return of(null);
          }),
        );
    }),
    shareReplay({ refCount: true, bufferSize: 1 }),
  );
}
